import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { createQuery } from '@farfetched/core';
import { getEventTypes } from './api';
import type { GetEventTypesResponse } from './types';

export const EventTypesControlGate = createGate<void>();

const fxGetEventTypes = createEffect<void, GetEventTypesResponse, Error>().use(
  getEventTypes
);

export const eventTypesQuery = createQuery({
  name: 'EventTypes',
  effect: fxGetEventTypes,
  mapData: ({ result }) =>
    Array.isArray(result?.types)
      ? result.types.map((item) => ({
          id: item?.id,
          label: item?.title ?? '',
        }))
      : [],
});

sample({
  clock: EventTypesControlGate.open,
  source: EventTypesControlGate.status,
  filter: (status) => Boolean(status),
  target: eventTypesQuery.start,
});
